module.exports = __webpack_public_path__ + "static/media/icofont.e9c9d055.svg";